import getQuery from './get-query';

export default props => state => getQuery(state, props);
